import videojs from 'video.js';
import { getKeyMessage } from './utils';

const getCertificate = (drm: any) => (_: any, callback: any) => {
  const certificateUrl = new URL(drm.fairplay.certificate_url);
  certificateUrl.protocol = 'https';
  videojs.xhr(
    {
      method: 'GET',
      url: certificateUrl.href,
      responseType: 'arraybuffer',
    },
    (error, _, responseBody) => {
      if (error) {
        callback(error);
        return;
      }

      const certificate: any = new Uint8Array(responseBody);

      callback(null, certificate);
    }
  );
};

const getLicense =
  (drm: any) => (_: any, contentId: any, keyMessage: any, callback: any) => {
    const body = getKeyMessage({
      drm,
      keyMessage,
    });

    videojs.xhr(
      {
        method: 'POST',
        url: drm.fairplay.license_server_url,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': drm.fairplay.license_server_request_content_type,
        },
        body,
      },
      (error, _, responseBody) => {
        if (error) {
          callback(error);
          return;
        }

        callback(null, responseBody);
      }
    );
  };

export default function drmSetup(player: any, drm: any) {
  const emeOptions = {
    keySystems: {
      'com.apple.fps.1_0': {
        getCertificate: getCertificate(drm),
        getLicense: getLicense(drm),
      },
    },
  };
  player.eme(emeOptions);
  return {};
}
